﻿import React from 'react';
import './MyProfile.scss';
import { Grid, TableHead, TableContainer, Table, TableBody } from '@mui/material';
import { InfoLabel, StyledTableCell, StyledTableRow } from './PagesNavBar';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Tooltip from '@mui/material/Tooltip';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function Training({ ...props }) {
  function GetEffectiveContractDate(date) {
    var effectiveDate = new Date(date);
    return effectiveDate.toLocaleDateString();
  }

  function GetStatusIcon(code, desc) {
    switch (code) {
      case 'C':
        return (
          <Tooltip title={desc}>
            <TaskAltIcon sx={{ color: '#2e7d32' }} />
          </Tooltip>
        );
      case 'N':
        return (
          <Tooltip title={desc}>
            <ErrorOutlineIcon sx={{ color: '#ed6c02' }} />
          </Tooltip>
        );
      case 'X':
        return (
          <Tooltip title={desc}>
            <RemoveCircleOutlineIcon sx={{ color: '#9e9e9e' }} />
          </Tooltip>
        );
      default:
        return <div></div>;
    }
  }

  return (
    <div style={{ margin: '1em 0' }}>
      {props.trainingInfo && props.demographicInfo != null && (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <InfoLabel
            label="Effective Contract Date:"
            data={[GetEffectiveContractDate(props.demographicInfo.effectiveContractDate)]}
          />
          <InfoLabel label="Resident State:" data={[props.demographicInfo.residentState]} />

          <Grid size={12}>
            <hr className="infoLine" />
          </Grid>

          <TableContainer
            sx={{ overflowX: 'hidden', overflowY: 'auto', height: '500', borderRadius: '0.5em' }}
          >
            <Table
              sx={{
                // minWidth: 700,
                margin: '0 0 0 1em',
                borderRadius: '0.5em',
                overflow: 'hidden',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                '& .MuiTableHead-root': {
                  backgroundColor: '#1976d2',
                  '& .MuiTableCell-root': {
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                },
                '& .MuiTableRow-root:nth-of-type(even)': {
                  backgroundColor: '#f9f9f9',
                },
                '& .MuiTableRow-root:nth-of-type(odd)': {
                  backgroundColor: 'inherit',
                },
              }}
              aria-label="customized table"
            >
              <colgroup>
                <col width="50%" />
                <col width="25%" />
                <col width="25%" />
              </colgroup>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">{'Training'}</StyledTableCell>
                  <StyledTableCell align="left">{'Status'}</StyledTableCell>
                  <StyledTableCell align="left">{'Completion Date'}</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {props.trainingInfo != null &&
                  props.trainingInfo.map((t, index) => (
                    <StyledTableRow key={t.statusCode + '-' + index}>
                      <StyledTableCell align="left">{t.trainingCodeDesc}</StyledTableCell>
                      <StyledTableCell align="left">
                        {GetStatusIcon(t.statusCode, t.statusCodeDesc)}
                      </StyledTableCell>
                      <StyledTableCell align="left">{t.completionDateLabel}</StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </div>
  );
}
